module.exports = __webpack_public_path__ + "img/antes_despues_03.17ef1a27.png";